import { render } from "./ShortcutsSheet.vue?vue&type=template&id=4b067a24&scoped=true"
import script from "./ShortcutsSheet.vue?vue&type=script&lang=js"
export * from "./ShortcutsSheet.vue?vue&type=script&lang=js"

import "./ShortcutsSheet.vue?vue&type=style&index=0&id=4b067a24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b067a24"]])

export default __exports__